import { render, staticRenderFns } from "./WhatsappEdit.vue?vue&type=template&id=9b2c4ec4&scoped=true&"
import script from "./WhatsappEdit.vue?vue&type=script&lang=js&"
export * from "./WhatsappEdit.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappEdit.vue?vue&type=style&index=0&id=9b2c4ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2c4ec4",
  null
  
)

export default component.exports